module.exports = __webpack_public_path__ + "img/x-logo.5938fede.svg";